/**
 * @generated SignedSource<<8af8b9b312d42ea5b1146baf4bd8e529>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateInfluencerCategoriesMutationInput = {
  categories: ReadonlyArray<string>;
  clientMutationId?: string | null;
  otherContent?: string | null;
};
export type CampaignInputCategoryMutation$variables = {
  input: UpdateInfluencerCategoriesMutationInput;
};
export type CampaignInputCategoryMutation$data = {
  readonly updateInfluencerCategories: {
    readonly __typename: "Influencer";
    readonly influencerCategories: ReadonlyArray<{
      readonly categoryName: string;
      readonly mCategoryId: string;
      readonly otherContent: string | null;
    }>;
  } | {
    readonly __typename: "UpdateInfluencerCategoriesError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type CampaignInputCategoryMutation = {
  response: CampaignInputCategoryMutation$data;
  variables: CampaignInputCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mCategoryId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherContent",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerCategoriesError",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignInputCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerCategories",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerCategory",
                "kind": "LinkedField",
                "name": "influencerCategories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignInputCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerCategories",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerCategory",
                "kind": "LinkedField",
                "name": "influencerCategories",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8cbef3287e48f060793b5d5bf823005f",
    "id": null,
    "metadata": {},
    "name": "CampaignInputCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation CampaignInputCategoryMutation(\n  $input: UpdateInfluencerCategoriesMutationInput!\n) {\n  updateInfluencerCategories(input: $input) {\n    __typename\n    ... on Influencer {\n      influencerCategories {\n        mCategoryId\n        categoryName\n        otherContent\n        id\n      }\n      id\n    }\n    ... on UpdateInfluencerCategoriesError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b991d98c538aa9b679421fd834fb6ce";

export default node;
